import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { round } from "lodash";
import React from "react";
import Pointer from "@assets/Pointer2.svg";
import Scala from "@assets/Scala2.svg";

interface TachometerProps {
  value: number;
  max: number;
  label: string;
}

const Tachometer: React.FC<TachometerProps> = ({ value, max, label }) => {
  const rotation = (value / max) * 180;
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        visibility: value === 0 ? "hidden" : "visible",
      }}
    >
      <Tooltip title={round(value) + (max === 100 ? "%" : "/" + max)}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <Box
            sx={{
              width: "60%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              mx: "auto",
              alignItems: "center",
              visibility: value === 0 ? "hidden" : "visible",
            }}
          >
            <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
              <img
                src={Scala}
                alt="Scala"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "auto",
                }}
              />
              <img
                src={Pointer}
                alt="Pointer"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "auto",
                  transform: `rotate(${rotation}deg)`,
                  transition: "transform 0.5s ease",
                }}
              />
            </Box>
            <Typography
              fontSize="calc(0.3rem + 0.6vw)"
              sx={{
                transform: "translate(0,-50%)",
                visibility: value === 0 ? "hidden" : "visible",
              }}
            >
              {label}
            </Typography>
          </Box>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default Tachometer;
